(function () {

    // 'use strict';

    var isResizing = false,
        lastDownX = 0,
        listings = $('#results'),
        handle = $('#drag-handle');

    $(document).on('mousedown', '#drag-handle', function (e) {
        isResizing = true;
        lastDownX = e.clientX;
    });

    $(document).on('mousemove', function (e) {

        // We don't want to do anything if we aren't resizing.
        if (!isResizing)
            return;

        if (e.clientX < 500) {
            $('#results').addClass('single-col');
        } else {
            $('#results').removeClass('single-col');
        }

        if (e.clientX > 350 || e.clientX < 1600) {

            var widthX = e.clientX + 'px';

            $('#results').css({
                'width': widthX
            });

            $('#results + section').css({
                'padding-left': widthX
            });
        }

    }).on('mouseup', function (e) {
        // stop resizing
        isResizing = false;
    });

})();